import { render, staticRenderFns } from "./gifts-card.vue?vue&type=template&id=11b9b77e&"
import script from "./gifts-card.vue?vue&type=script&lang=js&"
export * from "./gifts-card.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports